@import '../../../../constants/spacing.module.less';

.tool-filters {
  align-items: center;
  margin: @space-16 0;
}

.filter-pill {
  border: 1px solid var(--gray-AFB3B6);
  border-radius: 16px;
  color: var(--grey-900);
  cursor: pointer;
  padding: @space-4 @space-8;
}

.filter-pill:hover {
  background: var(--grey-200);
}

.filter-pill--selected {
  background: var(--pill--actionable-filter--background-color);
  border-color: var(--blue-1D5AD8);
  color: var(--blue-1D5AD8);
}

.filter-pill--selected:hover {
  background: var(--pill--actionable-filter--background-color);
}
